import {IFormController, ILogService} from 'angular';
import {Set} from 'immutable';
import * as moment from 'moment';

import {IStation} from '../../api/api.types';
import {IDataValueApi} from '../../api/data-value-api.service';

export class BulkDataDownloadController {
  static readonly $inject = ['dataValueApi', '$log', '$timeout'];

  /**
   * Form for the overridenDate control.
   */
  bulkDataForm: IFormController;
  /**
   * Selected stations.
   */
  selectedStations: Set<IStation>;
  /**
   * Whether a loading operation is in progress.
   */
  loadingInProgress: boolean;
  /**
   * URL of the produced bulkData.
   */
  readyToDownload: boolean;



  constructor(private dataValueApi:IDataValueApi, private $log: ILogService, private $timeout: ng.ITimeoutService) {
    this.selectedStations = Set<IStation>();
    this.loadingInProgress = false;
    this.readyToDownload = false;
  }

  onSelectedStationsChange(selectedStations: Set<IStation>) {
    this.selectedStations = selectedStations;
  }

  downloadBulkData() {
    this.loadingInProgress = true;
    this.dataValueApi.getBulkData(this.selectedStations.map(station => station.id).toArray())
        .then((data) => {
            const byteArray = new Uint8Array(data.filecontent);
            const filename = data.filename;
            var blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            // Create a link element and click it to trigger the download
            var downloadLink = document.createElement('a');
            downloadLink.href = window.URL.createObjectURL(blob);
            downloadLink.download = filename;
            downloadLink.click();
        })
        .catch(error => {
          this.$log.error('Error retrieving bulk data.', error);
        })
        .finally(() => {
          this.loadingInProgress = false;
        });
  }

  prepareBulkData() {
    this.loadingInProgress = true;
    this.$timeout(() => {
        this.readyToDownload = true;
    }, 1000).finally(() => {
          this.loadingInProgress = false;
    });
  }

}


/** WEBPACK FOOTER **
 ** ./app/operational/bulk-data-download/bulk-data-download.controller.ts
 **/